module.exports = __webpack_public_path__ + "static/media/imgplus.23ac4b12.svg";